export default __webpack_public_path__ + "static/media/applePayLogo.9df3111b.svg";